import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isToday,
  isSameMonth,
  isSameDay,
  eachDayOfInterval,
} from "date-fns";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch, useSelector } from "react-redux";
import {
  createEvent,
  fetchAllUserEvents,
  fetchEventImage,
  fetchScheduleCategory,
  fetchSpecificChannel,
  fetchUsers,
  resetCreateEvent,
  uploadEventImage,
} from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";

const PAGE_SIZE = 20;

const EventRap = styled.div`
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #bac0d499;
  padding: 50px;
  @media (max-width: 1400px) {
    padding: 20px;
  }
  @media (max-width: 1330px) {
    padding: 10px;
  }

  .events-sub-1 h4 {
    color: #060b13;
    font-size: 20px;
    font-weight: 600;
  }
  .events-sub-1 p {
    color: #363d4f;
    font-size: 15px;
    font-weight: 400;
  }
  .events-1 button {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 213px;
    height: 45px;
    color: #060b13;
    font-size: 14px;
    font-weight: 500;
    border-radius: 100px;
    border-color: #060b13;
  }
  .events-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
  .search-div-input input {
    border: 0.64px solid #bac0d4b2;
    padding-left: 30px;
    width: 268px;
    height: 40px;
    border-radius: 100px;
  }
  .search-div-input {
    width: 268px;
    position: relative;
  }
  .search-icon {
    position: absolute;
    left: 10px;
    top: 13px;
  }
  .filter-div p {
    color: #344054;
    font-weight: 400;
    font-size: 14px;
  }
  .filter-div {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0.64px solid #bac0d4b2;
    width: 92px;
    height: 40px;
    gap: 10px;
    border-radius: 100px;
  }
  .event-sub-2 {
    display: flex;
    gap: 20px;
  }
  .events-divs-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 30px;
  }
  .pagination-controls {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
  }
  .pagination-controls button {
    padding: 8px 16px;
    border-radius: 999px;
    border: 1px solid #bac0d4;
    background: #ffffff;
    color: #060b13;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }
  .pagination-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .pagination-controls span {
    font-size: 14px;
    color: #363d4f;
    font-weight: 500;
  }
  .events-text-divs {
    padding: 20px;
    border-radius: 5px;
    height: 246px;
    display: flex;
    width: 320px;
    flex-direction: column;
    justify-content: flex-end;
    gap: 10px;
    cursor: pointer;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .events-text-divs h4 {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
  }
  .events-text-divs p {
    color: #dcdcdc;
    font-size: 12px;
    font-weight: 400;
  }
  .events-2 {
    border: 0.7px solid #bac0d499;
    border-radius: 20px;
    padding: 24px 32px;
    margin-top: 30px;
  }
  .timezone p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .timezone p a {
    text-decoration: none;
    color: #ed1c24;
  }
  .timezone {
    position: relative;
  }
  .timezone-dropdown {
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 15px;
    width: 300px;
    background: #ffffff;
    position: absolute;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .time-input,
  .calendar-container input {
    width: 210px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    border: 0.8px solid #bac0d4b2;

    font-weight: 400;
    font-size: 12px;
  }
  .time-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 207px;
    background: #ffffff;
    padding: 20px;
    margin-top: 10px;
    padding-right: 10px;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
  }
  .time-dropdown p {
    color: #060b13;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }
  .time-dropdown-div {
    max-height: 240px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
  .time-dropdown-div::-webkit-scrollbar {
    width: 6px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .time-dropdown-div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .time-dropdown-div::-webkit-scrollbar-button {
    display: none;
  }
  .the-time {
    padding: 10px;
    cursor: pointer;
    border-radius: 6px;
    color: #060b13;
    font-weight: 500;
    font-size: 12px;
  }
  .time-cancel {
    border: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    background: #ffffff;
  }
  .time-save {
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
    width: 66px;
    height: 32px;
    border-radius: 8px;
  }
  .calendar-container {
    position: relative;
    max-width: 344px;
  }

  .calendar-dropdown {
    position: absolute;
    top: 50px;
    right: 20%;
    background: white;
    border: 0.6px solid #d0d5dd;
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 344px;
    z-index: 10;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
    color: #1e1e1c;
    font-size: 14px;
    font-weight: 400;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .calendar-day {
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #1e1e1c;
    font-weight: 400;
  }

  .today {
    color: #ed1c24;
  }

  .selected {
    background: #ed1c24;
    color: white;
    border-radius: 50%;
  }

  .other-month {
    color: #828280;
  }
  .start-date-time {
    display: flex;
    gap: 10px;
  }
  .category-input {
    width: 430px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
  }
  .category-input p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 0px 15px;
  }
  .category {
    position: relative;
  }
  .category-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    background: #ffffff;
    width: 430px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 15px;
    padding: 10px;
    z-index: 9999;
    position: absolute;
    margin-top: 10px;
  }
  .category-dropdown p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
  }
  .category-dropdown p:hover {
    background: #e8e9eb;
    border-radius: 6px;
  }
  input,
  textarea {
    border: 0.8px solid #bac0d4b2;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding-left: 15px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-dropdown-div {
    max-width: 500px;
    max-height: 546px;
    background: #ffffff;
    border-radius: 16px;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }

  @media (max-width: 1300px) {
    .events-divs-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 700px) {
    .link-sub-event {
      flex-wrap: wrap;
      gap: 15px;
    }
  }
  @media (max-width: 500px) {
    .event-sub-2,
    .events-1 {
      flex-wrap: wrap;
    }
    .events-1 {
      flex-direction: column;
    }
  }
  @media (max-width: 750px) {
    .events-divs-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  @media (max-width: 400px) {
    .events-text-divs {
      width: 290px !important;
      background-position: left;
    }
    .events-2 {
      padding: 24px 10px !important;
    }
  }
`;

const Events = () => {
  const dispatch = useDispatch();
  const {
    sheduleCategory,
    eventImages,
    eventSuccessTwo,
    eventSuccess,
    userChannel,
    userEvents,
    eventloading,
    userData,
    loading,
    error,
  } = useSelector((state) => state.userData);

  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(
    "(GMT+01:00) West Central Africa"
  );

  const channelId = localStorage.getItem("pluglrUserChannelId");
  console.log(channelId);

  const [previewImage, setPreviewImage] = useState(null);

  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [selectedTime, setSelectedTime] = useState("Start Time");
  const [tempTime, setTempTime] = useState(selectedTime);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const currentMonth = new Date();

  const [timeMenuOpen, setTimeMenuOpen] = useState(false);

  const [chosenTime, setChosenTime] = useState("End Time");
  const [showPopSchedule, setShowPopSchedule] = useState(false);
  const [highlightedTime, setHighlightedTime] = useState("");
  const [showCategory, setShowCategory] = useState(false);
  const [selectedOption, setSelectedOption] = useState("default");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Select Category");
  const [eventsPage, setEventsPage] = useState(1);
  const [eventCreationError, setEventCreationError] = useState(null);

  const timezones = [
    "(GMT-08:00) Pacific Time (US & Canada)",
    "(GMT-05:00) Eastern Time (US & Canada)",
    "(GMT+00:00) Greenwich Mean Time",
    "(GMT+01:00) West Central Africa",
    "(GMT+05:30) India Standard Time",
    "(GMT+08:00) Singapore Time",
  ];
  const [formData, setFormData] = useState({
    title: "",
    channelId: channelId,
    startTime: "",
    endTime: "",
    category: "",
    description: "",
  });

  console.log(userChannel);
  const userId = userData?.data?.id;
  // console.log(userId);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    if (userChannel?.data?.events) {
      userChannel.data.events.forEach((event) => {
        if (!eventImages[event.id]) {
          dispatch(fetchEventImage(event.id));
        }
      });
    }
  }, [userChannel, dispatch, eventImages]);

  useEffect(() => {
    if (channelId) {
      dispatch(fetchSpecificChannel(channelId));
    }
  }, [dispatch, channelId]);

  useEffect(() => {
    dispatch(fetchScheduleCategory());
  }, [dispatch]);

  useEffect(() => {
    if (selectedTime !== "Start Time" && selectedDate !== null) {
      // Parse time string (e.g. "01:00 PM")
      const [time, modifier] = selectedTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      // Create combined Date object
      const combinedDate = new Date(selectedDate);
      combinedDate.setHours(hours);
      combinedDate.setMinutes(minutes);
      combinedDate.setSeconds(0);
      combinedDate.setMilliseconds(0);

      // Convert to timestamp
      const timestamp = combinedDate.getTime();

      // Update formData with the timestamp
      setFormData((prev) => ({
        ...prev,
        startTime: timestamp,
      }));
    }
  }, [selectedTime, selectedDate]);

  useEffect(() => {
    if (chosenTime !== "End Time" && selectedEndDate !== null) {
      // Parse time string (e.g. "01:00 PM")
      const [time, modifier] = chosenTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      // Create combined Date object
      const combinedDate = new Date(selectedEndDate);
      combinedDate.setHours(hours);
      combinedDate.setMinutes(minutes);
      combinedDate.setSeconds(0);
      combinedDate.setMilliseconds(0);

      // Convert to timestamp
      const timestamp = combinedDate.getTime();

      // Update formData with the timestamp
      setFormData((prev) => ({
        ...prev,
        endTime: timestamp,
      }));
    }
  }, [chosenTime, selectedEndDate]);

  useEffect(() => {
    if (selectedCategory !== "Select Category") {
      setFormData((prev) => ({
        ...prev,
        category: selectedCategory,
      }));
    }
  }, [selectedCategory]);

  const handlePopSchedule = () => {
    setShowPopSchedule(!showPopSchedule);
  };
  const handleShowCategory = () => {
    setShowCategory((prev) => !prev);
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category); // Update the selected category
    setShowCategory(false); // Close the dropdown
  };

  const handleTimezoneChange = (timezone) => {
    setSelectedTimezone(timezone);
    setShowDropdown(false); // Close the dropdown after selection
  };
  // Generate time options in 12-hour format
  const generateTimes = () => {
    const times = [];
    for (let hour = 1; hour <= 12; hour++) {
      for (let minutes = 0; minutes < 60; minutes += 1) {
        const formattedHour = hour.toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        times.push(`${formattedHour}:${formattedMinutes} AM`);
        times.push(`${formattedHour}:${formattedMinutes} PM`);
      }
    }
    return times;
  };

  const times = generateTimes();

  const handleTimeChange = (time) => {
    setTempTime(time);
  };

  const saveTime = () => {
    setSelectedTime(tempTime);
    setShowTimeDropdown(false);
  };

  const daysInMonth = eachDayOfInterval({
    start: startOfMonth(currentMonth),
    end: endOfMonth(currentMonth),
  });

  const handleDateClick = (date) => {
    setSelectedDate(new Date(date));
    setShowCalendar(false);
  };

  const handleEndDateClick = (date) => {
    setSelectedEndDate(new Date(date));
    setShowEndCalendar(false);
  };

  const renderHeader = () => {
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div className="calendar-header">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-label">
            {day}
          </div>
        ))}
      </div>
    );
  };

  const renderDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day) => {
      const isCurrentMonth = isSameMonth(day, currentMonth);
      const isTodayDate = isToday(day);
      const isSelected = selectedDate && isSameDay(day, selectedDate);

      return (
        <div
          key={day.toISOString()}
          onClick={() => handleDateClick(day)}
          className={`calendar-day 
                  ${isTodayDate ? "today" : ""} 
                  ${isSelected ? "selected" : ""} 
                  ${!isCurrentMonth ? "other-month" : ""}
              `}
        >
          {format(day, "d")}
        </div>
      );
    });
  };

  const renderEndHeader = () => {
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div className="calendar-header">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-label">
            {day}
          </div>
        ))}
      </div>
    );
  };
  const renderEndDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day) => {
      const isCurrentMonth = isSameMonth(day, currentMonth);
      const isTodayDate = isToday(day);
      const isSelected = selectedEndDate && isSameDay(day, selectedEndDate);

      return (
        <div
          key={day.toISOString()}
          onClick={() => handleEndDateClick(day)}
          className={`calendar-day 
                  ${isTodayDate ? "today" : ""} 
                  ${isSelected ? "selected" : ""} 
                  ${!isCurrentMonth ? "other-month" : ""}
              `}
        >
          {format(day, "d")}
        </div>
      );
    });
  };

  // Function to generate times in the desired format
  const createTimeOptions = () => {
    const timeOptions = [];
    for (let hour = 1; hour <= 12; hour++) {
      for (let minute = 0; minute < 60; minute++) {
        const formattedHour = hour.toString().padStart(2, "0");
        const formattedMinute = minute.toString().padStart(2, "0");
        timeOptions.push(`${formattedHour}:${formattedMinute} AM`);
        timeOptions.push(`${formattedHour}:${formattedMinute} PM`);
      }
    }
    return timeOptions;
  };

  // Generate the time options
  const availableTimes = createTimeOptions();

  const updateTimeSelection = (time) => {
    setHighlightedTime(time);
  };

  const confirmTimeSelection = () => {
    setChosenTime(highlightedTime);
    setTimeMenuOpen(false);
  };

  const handleRadioChange = (event) => {
    const { value } = event.target;
    setSelectedOption(value);
    if (value === "default") {
      setUploadedImage(null);
      setPreviewImage(null);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedImage(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleGoToDetails = (id) => {
    navigate(`/users/eventsdetails/${id}`);
  };
  const handleCloseEventCreate = () => {
    dispatch(resetCreateEvent());
    setShowPopSchedule(false);
  };

  const getSelectedImageFile = useCallback(async () => {
    if (selectedOption === "upload" && uploadedImage) {
      return uploadedImage;
    }

    try {
      const defaultImagePath = "/images/image_1.png";
      const response = await fetch(defaultImagePath);
      if (!response.ok) {
        throw new Error(`Failed to load default image: ${response.status}`);
      }
      const blob = await response.blob();
      const fileName = defaultImagePath.split("/").pop() || "default_theme.png";
      return new File([blob], fileName, { type: blob.type || "image/png" });
    } catch (error) {
      console.error("getSelectedImageFile", error);
      return null;
    }
  }, [selectedOption, uploadedImage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEventCreationError(null);

    try {
      const createdEvent = await dispatch(createEvent(formData)).unwrap();
      const evtId = createdEvent?.data?.id;

      if (!evtId) {
        setEventCreationError("Unable to create event. Please try again.");
        return;
      }

      const imageFile = await getSelectedImageFile();
      if (!imageFile) {
        setEventCreationError("No image file available for upload");
        return;
      }

      await dispatch(
        uploadEventImage({ evt_id: evtId, file: imageFile })
      ).unwrap();

      setSelectedOption("default");
      setUploadedImage(null);
      setPreviewImage(null);
      setShowPopSchedule(false);
    } catch (error) {
      console.error("handleSubmit", error);
      setEventCreationError(
        error?.message ||
          error?.data?.message ||
          "Failed to create event. Please try again."
      );
    }
  };

  const resetEventsPage = useCallback(() => {
    setEventsPage(1);
  }, []);

  useEffect(() => {
    if (userId) {
      resetEventsPage();
    }
  }, [resetEventsPage, userId]);

  useEffect(() => {
    if (!userId) {
      return;
    }

    dispatch(
      fetchAllUserEvents({ userId, page: eventsPage, pageSize: PAGE_SIZE })
    );
  }, [dispatch, eventsPage, userId]);

  const getEventsPayload = (events) => events?.data || events?.events || events;

  const userEventCards = useMemo(() => {
    const payload = getEventsPayload(userEvents);
    if (!Array.isArray(payload) || payload.length === 0) {
      return [];
    }

    return payload.map((item) => {
      const id = item?.id || item?.eventId;
      const fallbackImage =
        item?.imageUrl && item.imageUrl.trim() !== ""
          ? item.imageUrl
          : item?.bgImage && item.bgImage.trim() !== ""
          ? item.bgImage
          : "/images/image_1.png";

      return {
        id,
        title: item?.title || "Untitled event",
        startTime: item?.startTime,
        endTime: item?.endTime,
        bgImage: eventImages?.[id] || fallbackImage,
      };
    });
  }, [eventImages, userEvents]);

  useEffect(() => {
    const payload = getEventsPayload(userEvents);

    if (!Array.isArray(payload) || payload.length === 0) {
      return;
    }

    payload.forEach((item) => {
      const id = item?.id || item?.eventId;
      if (!id || eventImages?.[id]) {
        return;
      }

      dispatch(fetchEventImage(id));
    });
  }, [dispatch, eventImages, userEvents]);

  const handleEventsPrev = () => {
    setEventsPage((prev) => Math.max(1, prev - 1));
  };

  const handleEventsNext = () => {
    if (userEventCards.length < PAGE_SIZE) {
      return;
    }

    setEventsPage((prev) => prev + 1);
  };

  return (
    <EventRap>
      <div className="events-1">
        <div className="events-sub-1">
          <h4>Events</h4>
          <p>Create, manage and share recordings</p>
        </div>
        <button onClick={handlePopSchedule}>Schedule for later</button>
      </div>
      <div className="events-2">
        <div className="event-sub-2">
          <div className="search-div-input">
            <input type="text" placeholder="Search" />
            <Icon
              className="search-icon"
              icon="material-symbols:search"
              width="16"
              height="16"
              style={{ color: "#363d4f", cursor: "pointer" }}
            />
          </div>
          <div className="filter-div">
            <img src="/images/filter-lines.svg" alt="" />

            <p>Filter</p>
          </div>
        </div>
        <div className="events-divs-grid">
          {loading ? (
            <div
              style={{
                gridColumn: "1 / -1",
                display: "flex",
                justifyContent: "center",
                padding: "40px 0",
              }}
            >
              <ClipLoader size={40} color="#ED1C24" />
            </div>
          ) : userEventCards.length === 0 ? (
            <div
              style={{
                gridColumn: "1 / -1",
                textAlign: "center",
                color: "#818893",
                padding: "40px 0",
              }}
            >
              You have no events yet. Create one to get started!
            </div>
          ) : (
            userEventCards.map((event) => (
              <div
                className="events-text-divs"
                key={event.id}
                style={{
                  background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
                onClick={() => handleGoToDetails(event.id)}
              >
                <h4>{event.title}</h4>
                <p>
                  {event.startTime
                    ? new Date(event.startTime).toLocaleString()
                    : ""}
                  {event.startTime && event.endTime ? " - " : ""}
                  {event.endTime
                    ? new Date(event.endTime).toLocaleString()
                    : ""}
                </p>
              </div>
            ))
          )}
        </div>
        {!loading && userEventCards.length > 0 && (
          <div className="pagination-controls">
            <button onClick={handleEventsPrev} disabled={eventsPage === 1}>
              Previous
            </button>
            <span>Page {eventsPage}</span>
            <button
              onClick={handleEventsNext}
              disabled={userEventCards.length < PAGE_SIZE}
            >
              Next
            </button>
          </div>
        )}
      </div>
      <div>
        {showPopSchedule ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="dropdown-header">
                <h4>Schedule for later</h4>
                <Icon
                  onClick={handlePopSchedule}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
              <div className="dropdown-div">
                <div>
                  <input
                    className="schedules-inputs"
                    type="text"
                    placeholder="Event title"
                    value={formData.title} // bind the input value to state
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        title: e.target.value, // update only the title field
                      }))
                    }
                  />
                </div>
                {/* <div className="timezone">
                  <p>
                    Current timezone: {selectedTimezone}{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowDropdown(!showDropdown);
                      }}
                    >
                      Change the zone
                    </a>
                  </p>

                  {showDropdown && (
                    <ul
                      className="timezone-dropdown"
                      style={{
                        listStyleType: "none",
                      }}
                    >
                      {timezones.map((zone, index) => (
                        <li
                          key={index}
                          onClick={() => handleTimezoneChange(zone)}
                          style={{
                            padding: "10px",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = "#f0f0f0")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "white")
                          }
                        >
                          {zone}
                        </li>
                      ))}
                    </ul>
                  )}
                </div> */}
                <div className="start-date-time">
                  <div>
                    <div
                      onClick={() => setShowTimeDropdown(!showTimeDropdown)}
                      className="time-input"
                    >
                      <span>{selectedTime}</span>
                      <span></span>
                    </div>

                    {showTimeDropdown && (
                      <div className="time-dropdown">
                        <p style={{ fontWeight: "bold" }}>Select time</p>
                        <div className="time-dropdown-div">
                          {times.map((time, index) => (
                            <div
                              className="the-time"
                              key={index}
                              onClick={() => handleTimeChange(time)}
                              style={{
                                border:
                                  tempTime === time
                                    ? "0.7px solid #BAC0D499"
                                    : "none",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border =
                                  "0.7px solid #BAC0D499")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border =
                                  tempTime === time
                                    ? "0.7px solid #BAC0D499ue"
                                    : "none")
                              }
                            >
                              {time}
                            </div>
                          ))}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            onClick={() => setShowTimeDropdown(false)}
                            className="time-cancel"
                          >
                            Cancel
                          </button>
                          <button onClick={saveTime} className="time-save">
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="calendar-container">
                    {/* Date Input */}
                    <input
                      type="text"
                      value={selectedDate ? format(selectedDate, "PPP") : ""}
                      placeholder="Start Date"
                      readOnly
                      onClick={() => setShowCalendar(!showCalendar)}
                    />

                    {/* Calendar Dropdown */}
                    {showCalendar && (
                      <div className="calendar-dropdown">
                        {renderHeader()}
                        <div className="calendar-grid">{renderDays()}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="start-date-time">
                  <div
                    className="event-date-time"
                    style={{ maxWidth: "344px" }}
                  >
                    {/* Time Selector */}
                    <div>
                      <div
                        onClick={() => setTimeMenuOpen(!timeMenuOpen)}
                        className="time-input"
                      >
                        <span>{chosenTime}</span>
                      </div>

                      {timeMenuOpen && (
                        <div
                          className="time-dropdown"
                          style={{
                            padding: "10px",
                            border: "0.6px solid #D0D5DD",
                          }}
                        >
                          <p style={{ fontWeight: "bold" }}>Select time</p>
                          <div
                            className="time-dropdown-div"
                            style={{ maxHeight: "150px", overflowY: "scroll" }}
                          >
                            {availableTimes.map((timeOption, index) => (
                              <div
                                className="the-time"
                                key={index}
                                onClick={() => updateTimeSelection(timeOption)}
                                style={{
                                  padding: "10px",
                                  border:
                                    highlightedTime === timeOption
                                      ? "0.7px solid #BAC0D499"
                                      : "none",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.border =
                                    "0.7px solid #BAC0D499")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.border =
                                    highlightedTime === timeOption
                                      ? "0.7px solid #BAC0D499"
                                      : "none")
                                }
                              >
                                {timeOption}
                              </div>
                            ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <button
                              onClick={() => setTimeMenuOpen(false)}
                              className="time-cancel"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={confirmTimeSelection}
                              className="time-save"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="calendar-container">
                    {/* Date Input */}
                    <input
                      type="text"
                      value={
                        selectedEndDate ? format(selectedEndDate, "PPP") : ""
                      }
                      placeholder="End Date"
                      readOnly
                      onClick={() => setShowEndCalendar(!showEndCalendar)}
                    />

                    {/* Calendar Dropdown */}
                    {showEndCalendar && (
                      <div className="calendar-dropdown">
                        {renderEndHeader()}
                        <div className="calendar-grid">{renderEndDays()}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="category">
                  <div onClick={handleShowCategory} className="category-input">
                    <p>{selectedCategory}</p>{" "}
                    {/* Display the selected category */}
                  </div>
                  {showCategory && (
                    <div className="category-dropdown">
                      {JSON.parse(sheduleCategory?.data).map(
                        (category, index) => (
                          <p
                            key={index}
                            onClick={() => handleSelectCategory(category)}
                          >
                            {category}
                          </p>
                        )
                      )}
                    </div>
                  )}
                </div>
                <div>
                  <textarea
                    className="schedules-inp"
                    style={{
                      height: "120px",
                      borderRadius: "15px",
                      textAlign: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    type="text"
                    placeholder="Event Description"
                    value={formData.description} // bind the input value to state
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        description: e.target.value, // update only the title field
                      }))
                    }
                  />
                </div>
                <div className="add-uploaded-divs">
                  <div>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="default"
                        checked={selectedOption === "default"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Use default theme
                    </label>

                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="upload"
                        checked={selectedOption === "upload"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Upload image
                    </label>
                  </div>

                  {selectedOption === "default" && (
                    <div>
                      <img
                        className="uploadedImage-default"
                        src="/images/image_1.png" // Replace with your default image URL
                        alt="Default Theme"
                        style={{
                          width: "300px",
                          height: "150px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  )}

                  {selectedOption === "upload" && (
                    <div>
                      {!uploadedImage ? (
                        <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              Choose Image
                              <input
                                onChange={handleImageUpload}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      ) : (
                        <img
                          className="uploadedImage-default"
                          src={previewImage}
                          alt="Uploaded"
                          style={{
                            width: "300px",
                            height: "150px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                <button onClick={handleSubmit} className="schedule-btn">
                  {eventloading ? (
                    <ClipLoader color="white" size={40} />
                  ) : (
                    "Schedule event"
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {eventSuccess ? (
        <div className="dropdown-container">
          <div className="all-dropdown-div">
            <div className="dropdown-div">
              <p
                style={{
                  margin: "auto",
                  fontSize: "20px",
                  maxWidth: "300px",
                  fontWeight: "600",
                  paddingBottom: "30px",
                }}
              >
                {eventSuccess?.message}
              </p>
              <button onClick={handleCloseEventCreate} className="schedule-btn">
                CLOSE
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {eventCreationError && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "16px",
              width: "400px",
              maxWidth: "90%",
              padding: "30px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                background: "#fee2e2",
                color: "#dc2626",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Icon icon="mdi:alert-circle" width="40" height="40" />
            </div>
            <h3
              style={{
                fontSize: "22px",
                fontWeight: "600",
                color: "#060b13",
                margin: 0,
              }}
            >
              Error
            </h3>
            <p
              style={{
                fontSize: "16px",
                color: "#475467",
                lineHeight: "1.5",
                margin: 0,
              }}
            >
              {eventCreationError}
            </p>
            <button
              onClick={() => setEventCreationError(null)}
              style={{
                background: "#ed1c24",
                color: "white",
                border: "none",
                padding: "12px 30px",
                borderRadius: "100px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                width: "100%",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </EventRap>
  );
};

export default Events;
